if (!customElements.get("countdown-timer-2")) {
  customElements.define(
    "countdown-timer-2",
    class CountdownTimer extends HTMLElement {
      constructor() {
        super();
        // Bind the updateCountdown method to ensure the correct this context
        this.updateCountdown = this.updateCountdown.bind(this);
      }

    
    connectedCallback() {
  this._initProperties();

  if (!this.timerDisplay) {
    console.error("Timer display element not found.");
    return;
  }

  if (isNaN(this.endDate)) {
    if (this.timerError) {
      this.timerError.innerHTML = `${this.translations.invalidDate}`;
    }
    return;
  }

  const now = new Date().getTime();
  const storageKey = `cd-timer-${this.dataset.blockId}`;
  const storedEndTime = parseInt(localStorage.getItem(storageKey));

  // FIRST check original timer
        if (this.endDate <= now) {

        // Original timer expired -> check if reset timer already exists
        if (storedEndTime && storedEndTime > now) {
            // continue reset timer
            this.endDate = storedEndTime;
        } else {
            // start new reset timer
            const resetMinutes = Number(this.getAttribute("reset-time")) || 5;
            this.endDate = now + resetMinutes * 60 * 1000;
            localStorage.setItem(storageKey, this.endDate);
        }
        } else {
            // original timer still active
            this.endDate = this.endDate;
        }
  this.updateCountdown();
  this.interval = setInterval(() => this.updateCountdown(), 1000);
}

      // Update the countdown timer display
      updateCountdown() {
        const now = new Date().getTime();
        let distance = this.endDate - now;

        // If the time is up dont reset, keep 0
        if (distance < 0) {
          this.timerDisplay.innerHTML = `
            <div class="wt-counter__item">
              <div class="wt-counter__item__value">00</div>
              <div class="wt-counter__item__label">${this.translations.days}</div>
            </div>
            <div class="wt-counter__item">
              <div class="wt-counter__item__value">00</div>
              <div class="wt-counter__item__label">${this.translations.hours}</div>
            </div>
            <div class="wt-counter__item">
              <div class="wt-counter__item__value">00</div>
              <div class="wt-counter__item__label">${this.translations.minutes}</div>
            </div>
            <div class="wt-counter__item">
              <div class="wt-counter__item__value">00</div>
              <div class="wt-counter__item__label">${this.translations.seconds}</div>
            </div>`;
          clearInterval(this.interval);
          return;
        }

        // If the time hasn't passed keep countdown
        const days = String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, "0");
        const hours = String(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, "0");
        const minutes = String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, "0");
        const seconds = String(Math.floor((distance % (1000 * 60)) / 1000)).padStart(2, "0");

        this.timerDisplay.innerHTML = `
          <div class="wt-counter__item">
            <div class="wt-counter__item__value">${days}</div>
            <div class="wt-counter__item__label">${this.translations.days}</div>
          </div>
          <div class="wt-counter__item">
            <div class="wt-counter__item__value">${hours}</div>
            <div class="wt-counter__item__label">${this.translations.hours}</div>
          </div>
          <div class="wt-counter__item">
            <div class="wt-counter__item__value">${minutes}</div>
            <div class="wt-counter__item__label">${this.translations.minutes}</div>
          </div>
          <div class="wt-counter__item">
            <div class="wt-counter__item__value">${seconds}</div>
            <div class="wt-counter__item__label">${this.translations.seconds}</div>
          </div>`;
      }

      disconnectedCallback() {
        // Clear the interval when the element is removed from the DOM
        clearInterval(this.interval);
      }

      // Initialize component properties
      _initProperties() {
        const endDateString = this.getAttribute("end-date");
        this.endDate = Date.parse(endDateString.replace(/-/g, "/"));
        this.expiredMessage = this.getAttribute("expired-message");
        this.timerDisplay = this.querySelector(".wt-countdown-timer__display");
        this.timerError = this.querySelector(".wt-countdown-timer__error");
        const useLongLabels = this.hasAttribute("data-long-labels");
        this.translations = {
          days: useLongLabels
            ? this.getAttribute("data-translation-days-long")
            : this.getAttribute("data-translation-days") || "d",
          hours: useLongLabels
            ? this.getAttribute("data-translation-hours-long")
            : this.getAttribute("data-translation-hours") || "h",
          minutes: useLongLabels
            ? this.getAttribute("data-translation-minutes-long")
            : this.getAttribute("data-translation-minutes") || "m",
          seconds: useLongLabels
            ? this.getAttribute("data-translation-seconds-long")
            : this.getAttribute("data-translation-seconds") || "s",
          invalidDate:
            this.getAttribute("data-translation-invalid-date") ||
            "Invalid date format. Please enter the date and time in the format YYYY-MM-DD HH:MM.",
        };
      }
    },
  );
}
